import {Group} from 'src/design/atoms/Group';
import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {UserGroupSimpleResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {
  ActiveInactivePills,
  IdpManagedPill,
  YesNoPills,
} from 'src/shared/constants/PillConstants';
import {
  ActiveStateDataOptions,
  YesNoStateDataOptions,
} from 'src/shared/constants/columnFilterData';

export const useUserGroupColumns = () => {
  const columns = useMemo<MRT_ColumnDef<UserGroupSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
        Cell: ({row}) => (
          <Group gap="xs" wrap="nowrap">
            <span>{row.original.name}</span>
            {row.original.isIdpManaged === true && (
              <Pill text={IdpManagedPill.text} color={IdpManagedPill.color} />
            )}
          </Group>
        ),
      },
      {
        accessorKey: 'active',
        header: 'Active',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: ActiveStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean | undefined>();
          const pillConfig = ActiveInactivePills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'isNotificationGroup',
        header: 'Notifications',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: YesNoStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean | undefined>();
          const pillConfig = YesNoPills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'isPermissionGroup',
        header: 'Permissions',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: YesNoStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean | undefined>();
          const pillConfig = YesNoPills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'isDefaultEmployeeGroup',
        header: 'Default Employees',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: YesNoStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean | undefined>();
          const pillConfig = YesNoPills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'isDefaultContractorGroup',
        header: 'Default Contractors',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: YesNoStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean | undefined>();
          const pillConfig = YesNoPills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
    ],
    []
  );

  return columns;
};
